export default __webpack_public_path__ + "static/media/Landing.2e57e611.jpg";